import {process} from "@progress/kendo-data-query";
import {useEffect, useState} from "react";
import useFetch from "../../tools/UseFetch";
import config from "../../config/config.json";
import Waiting from "../waiting/Waiting";
import useClientStore from "../../stores/ClientStore";
import useProjectStore from "../../stores/ProjectStore";
import useTmsStore from "../../stores/TmsStore";
import ExpenseInGrid from "./ExpenseInGrid";
import ExpenseEdit from "./ExpenseEdit";
import useExpenseStore from "../../stores/ExpenseStore";


const Expense = props => {

    const {selectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient}))
    const {selectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem}))

    const initialDataState = {
        take: 100,
        skip: 0,
        // filter: {
        //     logic: "or",
        //     filters: [
        //         { field: "ProjectID", operator: "eq", value: selectedProject.ID },
        //     ]
        // },
        sort: [
            { field: "Date", dir: "desc" }
        ]
    };

    const [dataState, setDataState] = useState(initialDataState);

    const data = useExpenseStore(state => state.expense)
    const isLoading = useExpenseStore(state => state.isLoading)
    const loadExpenseForProject = useExpenseStore(state => state.loadExpenseForProject)
    const addNew = useExpenseStore(state => state.addNew)
    const saveNew = useExpenseStore(state => state.saveNew)
    const saveItem = useExpenseStore(state => state.saveItem)


    const { data:expenseTypes, isPending:workType_isPending, error:workType_error} = useFetch(config.API_URL + 'lists/expense_type/', 1)
    const { data:authors, isPending:authors_isPending, error:authors_error} = useFetch(config.API_URL + 'user/authors/', 1)
    const { data:projects, isPending:projects_isPending, error:projects_error} = useFetch(config.API_URL + 'project/for_lists', 1)
    const { data:actual_user, isPending:actual_user_isPending, error:actual_user_error} = useFetch(config.API_URL + 'user/get_own_user', 1)
    const { data:currency, isPending:currency_isPending, error:currency_error} = useFetch(config.API_URL + 'lists/currency/', 1)

    const [filterSelectedPeriod, setFilterSelectedPeriod] = useState({value:{text:"tento měsíc", id:3}})
    const [showFilter, setShowFilter] = useState(false)
    const [filterOnlyProject, setFilterOnlyProject] = useState(true)
    const [filterOnlyMine, setFilterOnlyMine] = useState(true)
    const [filterText, setFilterText] = useState("")


    useEffect(() => {
        console.log("selected project in Expenses - ", selectedProject)
        loadExpenseForProject(selectedProject.ID)
    },[])


    // ********************************* helper data  *********************************

    const [editMode, setEditMode] = useState(false)
    const [editItem, setEditItem] = useState(null);


    // ************************************** EDIT *************************************

    const enterEdit = (dataItem) => {
        setEditItem(dataItem)
        setEditMode(true)
    };

    const handleCancelEdit = (dataItem) => {
        setEditMode(false);
    };

    const handleSubmit = (dataItem) => {
        // debugger
        if (dataItem.ID === undefined || dataItem.ID === null) {
            saveNew(dataItem)
        }
        else {
            saveItem(dataItem)
        }
        setEditMode(false);
    };


    // ************************************** NEW *************************************

    const newTms = () => {
        if (!actual_user) return

        const newItem = addNew()
        newItem.ProjectID = selectedProject

        const now = new Date()
        newItem.Date = new Date(now.getFullYear(), now.getMonth(), now.getDate())

        newItem.AuthorID = actual_user.ID

        setEditItem(newItem)
        setEditMode(true)
    }

    const closeEdit = () => {
        // setRefresh(Date.now())
        setEditMode(false)
    }

    return(
        <>

            {isLoading && <Waiting />}

            {data && authors && currency && expenseTypes && actual_user && <>

                {editMode && <ExpenseEdit close={closeEdit} project={selectedProject}
                                          projects={projects}
                                          authors={authors}
                                          expenseTypes={expenseTypes}
                                          currencies={currency}
                                          cancelEdit={handleCancelEdit}
                                          onSubmit={handleSubmit}
                                          item={editItem}
                />}

                {!editMode && <div className="tms">

                    <div className="space"></div>

                    <div className="page-body">

                        {/*{showFilter && <>*/}
                        {/*    <div className="tms-filter-space"></div>*/}
                        {/*</>}*/}

                        {process(data, dataState).data.map(record => (
                            // <div key={record.ID}>{record.text}</div>
                            <ExpenseInGrid key={record.ID} id={record.ID} record={record} authors={authors} currencies={currency} edit={enterEdit} />
                        ))}

                    </div>

                    <div className="tms-add-new-button" onClick={newTms}>+
                        {/*<ion-icon name="add-outline"></ion-icon>*/}
                    </div>

                </div>}

            </>}
        </>
    )
}

export default Expense
